import { ThemeConfig } from 'antd-v5';
import { Dispatch, SetStateAction } from 'react';

export const getAntdV5Theme: (
  isHighContrastMode?: boolean,
  setIsHighContrastMode?: Dispatch<SetStateAction<boolean>>,
) => ThemeConfig = (isHighContrastMode, setIsHighContrastMode) => ({
  token: {
    setIsHighContrastMode,
    colorPrimary: '#745CD1',
    colorLink: '#35198e',
    borderRadius: 6,
    fontFamily: 'InterVariable, sans-serif',
    fontSize: 13.75,
    colorText: 'rgb(52, 64, 84)',
    colorError: '#e32020',
    ...(isHighContrastMode
      ? {
          colorTextDescription: '#5C5C5C',
          colorTextPlaceholder: '#5C5C5C',
          colorTextDisabled: '#5C5C5C',
        }
      : {
          colorTextDescription: 'rgba(102, 112, 133 , .8)',
        }),
  },
  components: {
    Typography: {
      linkDecoration: 'underline',
    },
    Table: {
      headerBorderRadius: 0,
      cellPaddingBlockMD: 12,
      cellPaddingInlineMD: 16,
    },
    Drawer: {
      padding: 16,
      paddingLG: 24,
      fontSizeLG: 18,
    },
    Modal: {
      titleFontSize: 13.75,
      titleLineHeight: 1.7,
      titleColor: '#000',
      footerBg: '#F9FAFB',
      headerBg: '#F9FAFB',
      borderRadiusLG: 12,
    },
    Form: {
      labelColor: '#182230',
      itemMarginBottom: 16,
    },
    ...(isHighContrastMode
      ? {
          Select: {
            colorTextQuaternary: '#909090',
            colorBorder: '#909090',
          },
          Input: {
            colorBorder: '#909090',
          },
          Checkbox: {
            colorBorder: '#8E8E8E',
          },
          DatePicker: {
            colorBorder: '#909090',
          },
          Button: {
            colorLink: '#7442FF',
          },
        }
      : {
          Empty: {
            colorTextDescription: '#667085',
          },
        }),
  },
});
